export const LOCATIONS_PAGINATION_SIZE = 6;
